export default __webpack_public_path__ + "static/media/Soul of Pashtun.427b3e5c.jpg";